import React from "react";
import { getNightQueue, roleClass } from "../roles";

// Підказка "чия черга" для ведучого — головний біль будь-якого хоста,
// особливо новачка. Показуємо лише вночі й лише якщо в грі є хоч одна роль
// з нічною дією серед живих гравців.
export default function NightOrder({ players, actions, round }) {
  const queue = getNightQueue(players, actions, round);
  if (queue.length === 0) return null;

  const currentIndex = queue.findIndex((q) => !q.done);

  return (
    <div className="night-order">
      <h3>Черга ночі · Раунд {round}</h3>
      <ol className="night-order-list">
        {queue.map((q, i) => {
          const isCurrent = i === currentIndex;
          const names = q.players.map((p) => p.name).join(", ");
          return (
            <li
              key={q.stepId}
              className={`night-order-item ${
                q.done || q.deadRole ? "night-order-done" : ""
              } ${q.deadRole ? "night-order-dead" : ""} ${
                isCurrent ? "night-order-current" : ""
              }`}
            >
              <span className="night-order-marker" aria-hidden="true">
                {q.deadRole ? "†" : q.done ? "✓" : isCurrent ? "●" : "○"}
              </span>
              <span className="night-order-body">
                <span className={`night-order-role ${roleClass(q.roleId)}`}>
                  {q.roleLabel}
                </span>
                <span className="night-order-names"> · {names}</span>
                {q.deadRole ? (
                  // Роль мертва — ведучий все одно називає її вголос (щоб не
                  // "спалити" мовчанням), але дії від неї не чекає.
                  <span className="night-order-action"> — не в грі, лише озвучити</span>
                ) : (
                  <span className="night-order-action"> — {q.actionText}</span>
                )}
                {isCurrent && q.hint && (
                  <span className="night-order-hint"> ({q.hint})</span>
                )}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
